<template>
  <form class="fees-form" @submit.prevent="formSubmit">
    <div class="form">
      <div class="form-field row mb-3">
        <div class="form-field mb-3 col-md-6">
          <label
            >{{ $t("fees_form_how_many_years_label") }}
            <span class="text-highlighted"> *</span></label
          >
          <input
            :placeholder="$t('fees_form_how_many_years_placeholder')"
            type="number"
            required="required"
            class="form-control"
            v-model="feesFormData.years"
            @keyup="recalculateYears"
          />
        </div>
        <div class="form-field mb-3 col-md-6">
          <label
            >{{ $t("fees_form_how_much_monthly_installment_label") }}
            <span class="text-highlighted"> *</span></label
          >
          <input
            :placeholder="
              $t('fees_form_how_much_monthly_installment_placeholder')
            "
            type="number"
            required="required"
            class="form-control"
            v-model="feesFormData.monthly"
            @keyup="recalculateMonthly"
          />
        </div>
        <div class="form-field mb-3 col-md-12">
          <label
            >{{ $t("fees_form_how_much_is_planned_invested_amount_label") }}
            <span class="text-highlighted"> *</span></label
          >
          <input
            :placeholder="
              $t('fees_form_how_much_is_planned_invested_amount_placeholder')
            "
            type="number"
            required="required"
            class="form-control"
            v-model="feesFormData.investment"
            @keyup="recalculateInvestment"
          />
        </div>
      </div>
    </div>

    <label>{{ $t("fees_form_fee_payment_choice_label") }}</label>
    <div class="row mb-3">
      <b-form-radio-group
        v-model="feesFormData.payment"
        :required="true"
        buttons
        button-variant="outline-warning"
        class="col-12 w-100"
      >
        <b-form-radio :value="1" class="w-50">
          {{ $t("fees_form_fee_payment_choice_continuously") }}
        </b-form-radio>
        <b-form-radio :value="2" class="w-50">
          {{ $t("fees_form_fee_payment_choice_in_first_installments") }}
        </b-form-radio>
      </b-form-radio-group>
    </div>

    <FormGroup
      v-model="feesFormData"
      :fields="feesFormPaymentPercent"
      v-if="feesFormData.payment === 2"
    />
  </form>
</template>

<script>
import FormGroup from "./form/FormGroup";

export default {
  name: "FeesForm",
  components: {
    FormGroup
  },
  data() {
    return {
      feesFormData: {
        years: 0,
        monthly: 0,
        investment: 0,
        payment: 1,
        percent: 0
      },
      feesFormPaymentPercent: [
        {
          label: this.$t("fees_form_fee_how_much_in_first_installments"),
          type: "select",
          model: "percent",
          formWrapperClass: "col-md-12",
          required: true,
          options: [
            {
              label: this.$t("percent_from_installment", { percent: "10%" }),
              value: 10
            },
            {
              label: this.$t("percent_from_installment", { percent: "20%" }),
              value: 20
            },
            {
              label: this.$t("percent_from_installment", { percent: "25%" }),
              value: 25
            },
            {
              label: this.$t("percent_from_installment", { percent: "30%" }),
              value: 30
            },
            {
              label: this.$t("percent_from_installment", { percent: "40%" }),
              value: 40
            },
            {
              label: this.$t("percent_from_installment", { percent: "50%" }),
              value: 50
            }
          ]
        }
      ],
      sendData: null
    };
  },
  watch: {
    feesFormData: {
      deep: true,
      handler() {
        if (this.sendData) {
          clearTimeout(this.sendData);
        }
        this.sendData = setTimeout(this.setFeesData, 300);
      }
    }
  },
  mounted() {
    this.getStoredData();
  },
  methods: {
    recalculateYears() {
      if (this.feesFormData.monthly > 0 && this.feesFormData.years > 0) {
        this.feesFormData.investment =
          this.feesFormData.monthly * (this.feesFormData.years * 12);
      }
    },
    recalculateMonthly() {
      if (this.feesFormData.monthly > 0 && this.feesFormData.years > 0) {
        this.feesFormData.investment =
          this.feesFormData.monthly * (this.feesFormData.years * 12);
      }
    },
    recalculateInvestment() {
      if (this.feesFormData.investment > 0 && this.feesFormData.years > 0) {
        this.feesFormData.monthly = Math.round(
          this.feesFormData.investment / (this.feesFormData.years * 12)
        );
      }
    },
    setFeesData() {
      this.$store.commit("onboarding/setStrategyFeesData", this.feesFormData);
      this.$store.dispatch("onboarding/calculateFees");
    },
    getStoredData() {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const _that = this;
      this.$store.dispatch("onboarding/getFeesData").then(response => {
        _that.feesFormData = response.data.result.investmentData;
        _that.$parent.setClientStrategy({
          id: response.data.result.strategyId
        });
      });
    }
  }
};
</script>

<style scoped lang="scss">
.fees-form {
}
</style>
